import { FC, useMemo } from 'react';
import dayjs from 'dayjs';
import { ProDatePicker } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { DEFAULT_DATA_FORMAT, TABLE_COLUMN_EMPTY } from '../constants/constant';
import { RangePickerProps } from 'antd/lib/date-picker';

export interface SimpleFormRangePickerProps extends BaseSimpleFormProps {
  rangePickerProps?: RangePickerProps;
}
const SimpleFormRangePicker: FC<SimpleFormRangePickerProps> = props => {
  const { disabledRender, rangePickerProps, form, initialValue, ...restProps } = props;
  const handleRender = (val: any) => {
    if (disabledRender) return disabledRender;
    if (Array.isArray(val) && val.length === 2) {
      return val
        .map(v => {
          if (dayjs.isDayjs(v)) {
            // @ts-ignore
            return v.format(rangePickerProps?.format || DEFAULT_DATA_FORMAT);
          }
          return TABLE_COLUMN_EMPTY;
        })
        .join(' —— ');
    }
    return TABLE_COLUMN_EMPTY;
  };
  const initDayValue = useMemo(() => {
    if (Array.isArray(initialValue)) {
      return initialValue.map(v => dayjs.isDayjs(v) ? v : dayjs(v));
    }
  }, [initialValue]);
  
  return (
    <SimpleFormItem {...restProps} initialValue={initDayValue}>
      {rangePickerProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={handleRender}
        />
      ) : (
        <ProDatePicker.RangePicker
          style={DEFAULT_STYLE}
          format={DEFAULT_DATA_FORMAT}
          {...rangePickerProps}
        />
      )}
    </SimpleFormItem>
  );
};

SimpleFormRangePicker.displayName = SimpleFormItemEnum.SimpleFormRangePicker;

export default SimpleFormRangePicker;
